
import featureImage1 from '../assets/images/featured1.png'
import featureImage2 from '../assets/images/featured2.png'
import featureImage3 from '../assets/images/featured3.png'
const FeaturedCards = [
    {
        title : 'Up to 30% off ',
        badge : 'Select T-Shirt',
        desc : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae nunc, sed odio id nullam.',
        image : featureImage1
    },
    {
        title : 'New in this week!',
        badge : 'New to Sale',
        desc : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae nunc, sed odio id nullam.',
        image : featureImage2
    },
    {
        title : 'Latest Collection',
        badge : 'Latest Ever',
        desc : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae nunc, sed odio id nullam.',
        image : featureImage3
    }
];

export default FeaturedCards;